import { useMemo } from 'react';
import { useUnit } from 'effector-react';
import { $profileFeatureStore } from '@lib/store';
import { PermissionUtils } from '@shared/utils';
import type { CardFlow } from '@shared/api';

export const useCardFlow = (cardId?: number): CardFlow | null => {
  const { data } = useUnit($profileFeatureStore.store);

  return useMemo(() => PermissionUtils.findCardFlow(data?.cardFlows, cardId), [data?.cardFlows, cardId]);
};
